import React from 'react';
import PropTypes from 'prop-types';
import styles from './modal.module.scss';

class ModalInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
    };
    this.onCancel = this.onCancel.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      show: nextProps.show,
    });
  }

  onCancel() {
    this.props.onCancel();
  }

  render() {
    const cssClass = [styles.modal];
    if (this.state.show) {
      cssClass.push(styles.show);
    }
    return (
      <div className={cssClass.join(' ')}>
        <div className={styles.container}>
          {this.props.children}
        </div>
        <div
          role="link"
          tabIndex={0}
          className={styles.background}
          onClick={this.onCancel}
        />
      </div>
    );
  }
}

ModalInner.defaultProps = {
  show: false,
};

ModalInner.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
  show: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
};

export default ModalInner;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalInner.jsx